module.exports = __webpack_public_path__ + "static/img/bg-en.46ea095d.webp";